import moment from 'moment';

/**
 * Converts a string to a date object
 * @param  {string} dateString
 * @returns Date
 */
export function stringToDate(dateString: string): Date {
  return new Date(dateString);
}

/**
 * Converts Date to UNIX Timestamp
 * @param  {Date} date
 * @returns number
 */
export function toUnixTimestamp(date: Date): number {
  return Math.floor(date.getTime() / 1000);
}

/**
 * Converts UNIX Timestamp to Date
 * @param  {number} unixTimestamp
 * @returns Date
 */
export function fromUnixTimestamp(unixTimestamp: number): Date {
  return new Date(unixTimestamp * 1000);
}

/**
 * Returns how much time is yet to pass until the given date
 * @param  {number} date
 * @returns string
 */
export function fromNow(date: number): string {
  return moment(fromUnixTimestamp(date)).fromNow(true);
}
